module.exports = __webpack_public_path__ + "img/rules.d86c5886.png";